export default {
  data() {
    return {
      homeGeoJson: {
        type: 'FeatureCollection',
        features: [],
      }
    }
  },
  methods: {
    addHomesShapes: function (geojson, packageSummaryList) {
      return;
      packageSummaryList.forEach((hnl) => {
        const homejson = geojson.features.find((item) => {
          return item.properties.lotCpId === hnl.lotproductcpid;
        });
        if (homejson) {
          homejson.properties.level = 0;
          homejson.properties.height = 4;
          homejson.properties.base_height = 4;
          homejson.color = 'grey';
          this.homeGeoJson.features.push(homejson);
        }
      });

      this.map.addSource('homes', {
        type: 'geojson',
        data: this.homeGeoJson,
      });

      this.map.addLayer({
        id: 'homegeo',
        type: 'fill-extrusion',
        source: 'homes',
        minzoom: 15,
        paint: {
          'fill-extrusion-color': '#ddd',
          'fill-extrusion-height': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0,
            15.05,
            ['get', 'height'],
          ],
          'fill-extrusion-base': [
            'interpolate',
            ['linear'],
            ['zoom'],
            15,
            0,
            15.05,
            ['get', 'min_height'],
          ],
          'fill-extrusion-opacity': 0.9,
        },
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/map/Home.js